import script from "./UserModify.vue?vue&type=script&setup=true&lang=js"
export * from "./UserModify.vue?vue&type=script&setup=true&lang=js"

import "./UserModify.vue?vue&type=style&index=0&id=185a6a84&lang=css"

const __exports__ = script;

export default __exports__